export default __webpack_public_path__ + "static/media/logoSC.92b9096f.png";